module.exports = __webpack_public_path__ + "6dcbc518.png";